import { ReactNode, useMemo } from 'react';

export interface ApplyCardProps {
  children: ReactNode;
  noBottomPadding?: boolean;
  flex?: boolean;
}

const ApplyCard: React.FunctionComponent<ApplyCardProps> = function ({
  children,
  noBottomPadding = false,
  flex = false,
}) {
  const className = useMemo(
    () =>
      [
        'flex flex-col border border-neutral-300 rounded-xl bg-neutral-000 md:shadow-lg',
        noBottomPadding ? 'p-4 pb-0 md:p-6 md:pb-2' : 'p-4 md:p-6',
        flex ? 'flex-1' : '',
      ].join(' '),
    [noBottomPadding, flex],
  );
  return <div className={className}>{children}</div>;
};

export default ApplyCard;
